module.exports = __webpack_public_path__ + "img/bread-support.3c1e7680.png";